var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.color),attrs:{"id":"app"}},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("Color Picker")]),_c('ColorPresets',{on:{"color-change":_vm.changeColor}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }